import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';

const PaymentMethodsReport = ({ data }) => (
  <Box>
    <Typography variant="h5" gutterBottom>
      Payment Methods Report ({data.period.startDate} to {data.period.endDate})
    </Typography>
    
    <Grid container spacing={3} sx={{ mb: 4 }}>
      <Grid item xs={12} sm={6}>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>Total Amount</Typography>
            <Typography variant="h5">${parseFloat(data.summary.totalAmount || 0).toFixed(2)}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>Total Transactions</Typography>
            <Typography variant="h5">{data.summary.totalTransactions}</Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>

    <Typography variant="h6" gutterBottom>Payment Method Breakdown</Typography>
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Payment Method</TableCell>
            <TableCell align="right">Transactions</TableCell>
            <TableCell align="right">Total Amount</TableCell>
            <TableCell align="right">Percentage</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.breakdown.map((method) => (
            <TableRow key={method.payment_method}>
              <TableCell>{method.payment_method}</TableCell>
              <TableCell align="right">{method.transaction_count}</TableCell>
              <TableCell align="right">${parseFloat(method.total_amount || 0).toFixed(2)}</TableCell>
              <TableCell align="right">{method.percentage}%</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Box>
);

export default PaymentMethodsReport;
